import * as actionTypes from './actionTypes';

export const caseListFilter = filter => ({
  type: actionTypes.SET_CASE_LIST_FILTER,
  filter
})
export const resetCaseListFilter = filter => ({
  type: actionTypes.RESET_CASE_LIST_FILTER,
  filter
})



// WEBPACK FOOTER //
// ./src/components/CaseList/actions/actionCreator.js